import React from 'react'
import { DRAGGABLE_WINDOWS } from '../constants'
import Draggable from 'react-draggable';

import NoAvailableFloat from '../components/workSpace/floatingWindows/NoAvailableFloat.jsx';
import ManualCall from '../components/workSpace/floatingWindows/ManualCall.jsx'
import CallTransfer from '../components/workSpace/floatingWindows/CallTransfer.jsx';
import DTFMWindow from '../components/workSpace/floatingWindows/DTMFWindow.jsx';
import OngoingCallIvrWindow from '../components/workSpace/floatingWindows/OngoingCallIvrWindow.jsx';
import CallMark from '../components/workSpace/floatingWindows/CallMark.jsx';
import NoAvailableLocked from '../components/workSpace/noAvailableLocked.jsx';
import SuperVisorChatFloating from '../components/workSpace/floatingWindows/SuperVisorChatFloating.jsx';
import CallRecord from '../components/workSpace/floatingWindows/CallRecord.jsx';
import NoAvailableRecordFloating from '../components/workSpace/floatingWindows/NoAvailableRecordFloating.jsx';
import ExclusiveCallBack from '../components/workSpace/Others/ExclusiveCallBack.jsx'
import TemplatesWhatsapp from '../components/workSpace/floatingWindows/TemplatesWhatsapp.jsx'
import RateRecord from '../components/workSpace/floatingWindows/RateRecord';

export function manualCallWindow(props = {}, isManualMessage) {
  return {
    idComponent: isManualMessage ? DRAGGABLE_WINDOWS.MANUAL_MESSAGE : DRAGGABLE_WINDOWS.MANUAL_CALL,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key={isManualMessage ? 'manualMessage' : 'manualCall'}>
      <div className="manualCallContainer" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}>
        <ManualCall id={isManualMessage ? DRAGGABLE_WINDOWS.MANUAL_MESSAGE : DRAGGABLE_WINDOWS.MANUAL_CALL} objProps={{ propsData: props, propsAlert: propsComponent, isManualMessage }} goTopZ={(component) => newTopZIndex(component)} />
      </div>
    </Draggable>
  }
}

export function templatesWhatsappWindow(props = {}, setTemplateWhatsapp, templatesList) {
  return {
    idComponent: DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key={'templatesWhatsapp'}>
      <div className="templatesWhatsappContainer" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}>
        <TemplatesWhatsapp id={DRAGGABLE_WINDOWS.TEMPLATES_WHATSAPP} objProps={{ propsData: props, propsAlert: propsComponent, setTemplateWhatsapp, templatesList }} goTopZ={(component) => newTopZIndex(component)} />
      </div>
    </Draggable>
  }
}

export function transferCallWindow(props = {}) {
  return {
    idComponent: DRAGGABLE_WINDOWS.TRANSFER_CALL,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key="tranferCall">
      <div className="tranferCallContainer" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 174px)', left: 'calc(50% - 100px)' }}>
        <CallTransfer id={DRAGGABLE_WINDOWS.TRANSFER_CALL} objProps={{ propsData: props, propsAlert: propsComponent }} goTopZ={(component) => newTopZIndex(component)} />
      </div>
    </Draggable>
  }
}

export function dtmfTonesWindow(props = {},oncloseDtmfTonesWindow) {
  return {
    idComponent: DRAGGABLE_WINDOWS.DTMF_TONES,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key="dtmfTones">
      <div className="dtmfWindowContainer" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}>
        <DTFMWindow id={DRAGGABLE_WINDOWS.DTMF_TONES} objProps={props} goTopZ={(component) => newTopZIndex(component)} oncloseDtmfTonesWindow={oncloseDtmfTonesWindow} />
      </div>
    </Draggable>
  }
}

export function ongoingCallIvrWindow(props = {},onCloseIVR) {
  return {
    idComponent: DRAGGABLE_WINDOWS.ONGOING_CALL_IVR,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key="ongoingCallIvr">
      <div className="dtmfWindowContainer" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}>
        <OngoingCallIvrWindow id={DRAGGABLE_WINDOWS.ONGOING_CALL_IVR} objProps={props} goTopZ={(component) => newTopZIndex(component)} onCloseIVR={onCloseIVR}/>
      </div>
    </Draggable>
  }
}

export function callRecord(props = {}) {
  let xPosition = 150 - props.position.xPosition;
  let yPosition = 100 - props.position.yPosition;
  return {
    idComponent: DRAGGABLE_WINDOWS.CALL_RECORD,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key="callRecord" onDrag={props.dragFunc}>
      <div className="callRecordContainer" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - ' + yPosition + 'px)', left: 'calc(50% - ' + xPosition + 'px)' }}>
        <CallRecord id={DRAGGABLE_WINDOWS.CALL_RECORD} objProps={props} goTopZ={(component) => newTopZIndex(component)} />
      </div>
    </Draggable>
  }
}

export function markCallWindow(props = {}, initialDialogTime = 0, callout_id = 0, onCloseMarCallkWindow) {
  return {
    idComponent: DRAGGABLE_WINDOWS.MARK_CALL,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key="markCall">
      <div className="markCallContainer" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}>
        <CallMark id={DRAGGABLE_WINDOWS.MARK_CALL} objProps={props} goTopZ={(component) => newTopZIndex(component)} initialDialogTime={initialDialogTime} callout_id={callout_id} onCloseMarCallkWindow={onCloseMarCallkWindow}/>
      </div>
    </Draggable>
  }
}

export function noAvailableLocked(props = {}) {
  return {
    idComponent: DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <NoAvailableLocked key="NoAvailableFloating" goTopZ={(component) => newTopZIndex(component)} id={DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED} style={z_Index} />
  }
}

export function supervisorChatFloating(props = {}) {
  return {
    idComponent: DRAGGABLE_WINDOWS.SUPERVISOR_CHAT,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) =>
      <Draggable bounds="parent" handle="drag" key="supervisorChatFloating">
        <div className={`supervisorChatDragContainer ${props.regsMultiple ? 'displayBlock' : ''} `} style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}>
          <SuperVisorChatFloating id={DRAGGABLE_WINDOWS.SUPERVISOR_CHAT} objProps={props} goTopZ={(component) => newTopZIndex(component)} />
        </div>
      </Draggable>
  }
}

export function noAvailableFloating(props = {}) {
  return {
    idComponent: DRAGGABLE_WINDOWS.NO_AVAILABLE,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => 
    <Draggable bounds="parent" handle="drag" key="noAvailableFloating">
      <div className={`noAvailableDragContainer ${props.regsMultiple ? 'regsMultiple' : ''} `} style={{z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}>
        <NoAvailableFloat id={DRAGGABLE_WINDOWS.NO_AVAILABLE} objProps={props} z_Index={z_Index} goTopZ={(component) => newTopZIndex(component)} />
      </div>
    </Draggable>
  }
}

export function noAvailableRecordDrag(props = {}) {
  return {
    idComponent: DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable bounds="parent" handle="drag" key="noAvailableRecordFloating">
      <div className={`noAvailableRecordFloating   ${props.regsMultiple ? 'regsMultiple' : ''}`} style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 100px)' }}> 
        <NoAvailableRecordFloating id={DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD} objProps={props} goTopZ={(component) => newTopZIndex(component)} />
      </div>
    </Draggable>
  }
}

export function callBackEsclusive(props = {}) {
  return {
    idComponent: DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) =>
      <div className="callBackEsclusiveFloating" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 10.205rem)', left: 'calc((50% + 30px) - 8.08rem)' }}>
        <ExclusiveCallBack id={DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK} objProps={props} goTopZ={(component) => newTopZIndex(component)} />
      </div>
  }
}

export function rateRecordWindow(props = {}, initialDialogTime = 0, callout_id = 0, onCloseDispositionWindow) {
  return {
    idComponent: DRAGGABLE_WINDOWS.RATE_RECORD,
    componentProps: props,
    component: (propsComponent, z_Index, newTopZIndex) => <Draggable axis="y" key="rateRecordFloating">
      <div className="rateRecordContainer" id="recordWindow" style={{ zIndex: z_Index, position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(60% - 100px)'}}>
        <RateRecord id={DRAGGABLE_WINDOWS.RATE_RECORD} objProps={props} goTopZ={(component) => newTopZIndex(component)} initialDialogTime={initialDialogTime} callout_id={callout_id} onCloseDispositionWindow={onCloseDispositionWindow} />
      </div>
    </Draggable>
  }
}



// WEBPACK FOOTER //
// ./src/js/draggableComponents.js